import * as React from "react";
import {
    List,
    Show,
    Edit,
    Create,

    Datagrid,
    SimpleShowLayout,
    SimpleForm,
    TextField,
    EmailField,
    DateField,
    TextInput,
    DateInput,
    BooleanField,
    ArrayField,
    SelectField,
    SelectInput,

    TabbedShowLayout,
    Tab,
    Toolbar,
    SaveButton,
    useRecordContext,
    Button,
    NumberField,
    NumberInput,
    FormDataConsumer,
    WrapperField,
    FunctionField,
    TopToolbar,
    EditButton,
    Confirm,
    useDataProvider,
    useRedirect,
    useNotify,
    TabbedForm,
    ArrayInput,
    SimpleFormIterator,
    Link,
    CreateButton,
    ReferenceInput,
    AutocompleteInput,
    maxValue,
    useGetOne,
    usePermissions,
    AddItemButton,
    RichTextField,
    WithListContext,
    SingleFieldList,
    ChipField,
    SimpleList,
} from 'react-admin';
import { useController, useForm, useWatch } from "react-hook-form";
import Grid from '@mui/material/Grid';
import Alert from "@mui/material/Alert";
// import { QuizzBuilder, Quiz } from "react-quizzes"
// import "react-quizzes/lib/assets/antd.css";
// import "./Forms.css";
// import "./FormEdit.scoped.css";
// import { sectionChoices } from "../helpers";
// import {ReactFormeoEditor, ReactFormeoRenderer} from "../Components/Formeo";
// import { ShkeAdditionalInfoField, ShkeAdditionalInfoInput } from "../Components/AdditionalInfo";
import { ConditionalScoringField, FormEntryCommunityField } from "./FormEntries";
import { formStatuses, getStatuses, toSelectChoices } from "../helpers/strings";
import { authenticatedApi } from "../dataProvider";
// import { FormeoEditor, FormeoRenderer } from 'formeo'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import AddIcon from '@mui/icons-material/AddCircleOutline';
import { format, formatISO, parseISO } from "date-fns";
import { RichTextInput } from "ra-input-rich-text";
import { SimpleRichTextInputToolbar } from "../Components/SimpleRichTextInputToolbar";
import { AdditionalSchemaField, AdditionalSchemaInput } from "../Components/AdditionalSchema";

const scoringModeOptions = [
    { id: 'scored', name: 'Scored' },
    { id: 'scored_correctable', name: 'Scored with Ability to Correct & Resubmit' },
    { id: 'correctable', name: 'Correct Answers Before Submitting' },
];

const listFilters = [
    // <TextInput source="q" label="Search" alwaysOn />, // TODO: fix this
];

const CoordinatingProgramFormList = props => (
    <List title={"All Forms"} filters={listFilters} {...props} hasCreate>
        <Datagrid rowClick="show">
            <TextField source="form.name" label={'Form'} />
            <TextField source="coordinating_program.name" label="Coordinating Program" />
            <FunctionField label="Status" source="status" render={record => formStatuses[record.status] ?? record.status} />
        </Datagrid>
    </List>
);

export const FormField = (props) => {
    const record = useRecordContext(props);

    if(!record) {
        return null;
    }

    const formSchema = JSON.parse(record.schema);

    return null;

    // return <ReactFormeoRenderer formData={formSchema} values={[]} />
}

const FormPreview = (mode = 'show') => {
    const record = useRecordContext();
    // the record can be empty while loading
    if (!record) return null;

    const urlSuffix = mode === 'show' ? '/show' : '';

    return (<>
        <TableContainer component={Paper}>
            <Table aria-label="simple table">
                <TableHead>
                <TableRow>
                    <TableCell>Title</TableCell>
                    {/* <TableCell align="right">LP</TableCell> */}
                    {/* <TableCell align="right">CP</TableCell> */}
                    {/* <TableCell align="right">MSA</TableCell> */}
                </TableRow>
                </TableHead>
                <TableBody>
                <TableRow
                    sx={{ '& > *': {fontWeight: 'bold'}, '&:last-child td, &:last-child th': { border: 0 } }}
                >
                    <TableCell component="th" scope="row">Baseline Requirements</TableCell>
                </TableRow>
                {record.form.baseline_requirements.map((requirement) => (<React.Fragment key={requirement.name}>
                    <TableRow
                    sx={{ '& > *': {fontStyle: 'italic'}, 'th': {paddingLeft: 6}, '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                        <TableCell component="th" scope="row">
                            <Link to={`/form-baseline-requirements/${requirement.id}${urlSuffix}`}>
                                {requirement.description}
                            </Link>
                        </TableCell>
                    </TableRow>
                </React.Fragment>))}
                {record.form.standards.map((standard) => (<React.Fragment key={standard.name}>
                    <TableRow
                    sx={{ '& > *': {fontWeight: 'bold'}, '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                        <TableCell component="th" scope="row">
                            <Link to={`/form-standards/${standard.id}${urlSuffix}`}>
                                {standard.name}
                            </Link>
                            {/*
                            <div className="max-w-4xl text-black" dangerouslySetInnerHTML={{__html: standard.description.replaceAll(/\n/gi, '<br/><br/>') }}></div>

                            <h2 className="mt-6 text-2xl font-semibold">Focus Areas</h2>
                            <div className="max-w-4xl text-black" dangerouslySetInnerHTML={{__html: standard.focus_areas.replaceAll(/\n/gi, '<br/><br/>') }}></div>

                            <h2 className="mt-6 text-2xl font-semibold">Key Indicators</h2>
                            <div className="max-w-4xl text-black" dangerouslySetInnerHTML={{__html: standard.key_indicators_description.replaceAll(/\n/gi, '<br/><br/>') }}></div>
                            */}
                        </TableCell>
                        {/* <TableCell align="right">{scoreFor('standard', standard).lp}</TableCell> */}
                        {/* <TableCell align="right">{scoreFor('standard', standard).cp}</TableCell> */}
                        {/* <TableCell align="right">{scoreFor('standard', standard).msa}</TableCell> */}
                    </TableRow>
                    {standard.key_indicators.map((keyIndicator) => (<React.Fragment key={keyIndicator.name}>
                        <TableRow
                            sx={{ '& > *': {fontStyle: 'italic'}, 'th': {paddingLeft: 6}, '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                            <TableCell component="th" scope="row">
                                <Link to={`/form-key-indicators/${keyIndicator.id}${urlSuffix}`}>
                                    {keyIndicator.name}
                                </Link>
                            </TableCell>
                            {/* <TableCell align="right">{scoreFor('keyIndicator', keyIndicator).lp}</TableCell> */}
                            {/* <TableCell align="right">{scoreFor('keyIndicator', keyIndicator).cp}</TableCell> */}
                            {/* <TableCell align="right">{scoreFor('keyIndicator', keyIndicator).msa}</TableCell> */}
                        </TableRow>
                        {keyIndicator.indicators.map((indicator) => (<React.Fragment key={indicator.name}>
                            <TableRow
                                sx={{ 'th': {paddingLeft: 12}, '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell component="th" scope="row">
                                    <Link to={`/form-indicators/${indicator.id}${urlSuffix}`}>
                                        {indicator.name}
                                    </Link>
                                </TableCell>
                                {/* <TableCell align="right">{scoreFor('indicator', indicator).lp}</TableCell> */}
                                {/* <TableCell align="right">{scoreFor('indicator', indicator).cp}</TableCell> */}
                                {/* <TableCell align="right">{scoreFor('indicator', indicator).msa}</TableCell> */}
                            </TableRow>
                        </React.Fragment>))}
                    </React.Fragment>))}
                </React.Fragment>))}
                </TableBody>
            </Table>
        </TableContainer>
    </>);
};

const FormEntriesField = () => {
    const record = useRecordContext();

    const displayScore = record && record.scoring_mode && record.scoring_mode !== null && record.scoring_mode.indexOf('scored') !== -1;

    return (
        <ArrayField source="entries" label={false}>
            <Datagrid rowClick={(id, resource, record) => '/form-entries/'+id+'/show'} bulkActionButtons={false}>
                <FunctionField label="Status" source="status" render={record => getStatuses(record.status)} />
                <FormEntryCommunityField label="Community" source="community" />
                {/* <DateField source="created_at" label="Submitted Date" /> */}
            </Datagrid>
        </ArrayField>
    );
};

const FormScoringFields = () => {
    const record = useRecordContext();

    const displayScore = record && record.scoring_mode && record.scoring_mode !== null && record.scoring_mode.indexOf('scored') !== -1;

    if(!displayScore) {
        return null;
    }

    return (<>
        <SelectField source="scoring_mode" emptyValue={null} emptyText={'Not Scored'} choices={scoringModeOptions} />
        <NumberField source="minimum_score" />
    </>);

};

const FormShowActions = () => {
    const record = useRecordContext();
    const redirect = useRedirect();
    const notify = useNotify();
    const dataProvider = useDataProvider();
    const [user, setUser] = React.useState();
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState();

    const [open, setOpen] = React.useState(false);

    /*
    const [remove, { isLoading }] = useDelete(
        'posts',
        { id: record && record.id }
    );
    */

    const handleClick = () => setOpen(true);
    const handleDialogClose = () => setOpen(false);
    const handleConfirm = () => {
        setLoading(true);

        authenticatedApi.post(`/coordinating-program-forms/${record.id}/duplicate`).then(response => {
            redirect('show', 'forms', response.data.id);
            setLoading(false);
            notify('Form duplicated', {type: 'success'});
        });

        // remove();
        setOpen(false);
    };

    return (
    <TopToolbar>
        <Button color="primary" onClick={handleClick}><>Duplicate</></Button>
        <Confirm
            isOpen={open}
            loading={loading}
            title={`Duplicate form?`}
            content="Are you sure you want to duplicate this form?"
            onConfirm={handleConfirm}
            onClose={handleDialogClose}
        />

        <EditButton />
    </TopToolbar>
    );
};

const CoordinatingProgramFormShow = props => {
    const { permissions } = usePermissions();

    return (
    <Show {...props} actions={<FormShowActions/>}>
        {/* <SimpleShowLayout> */}
        <TabbedShowLayout>
            <Tab label="summary">
                <TextField source="form.name" label={'Form'} />
                <TextField source="coordinating_program.name" label="Coordinating Program" />
                <FunctionField label="Status" source="status" render={record => formStatuses[record.status] ?? record.status} />

                <DateField label="Close On" source="end_at" />
                <DateField label="National Close On" source="form.end_at" />
                <FunctionField label="Completion Redirect URL" render={record => record.completion_redirect_url || 'None'} />
                <FunctionField label="National Completion Redirect URL" render={record => record.form?.completion_redirect_url || 'None'} />
            </Tab>
            <Tab label="Form Questions">
                <AdditionalSchemaField/>
            </Tab>
            {/*
            <Tab label="Table of Contents">
                <em>Click on a title to navigate to that specific section.</em>
                {permissions.msa && (
                <div>
                <CreateButton resource="form-baseline-requirements" label="Add Baseline Requirement" />
                <br/>
                <CreateButton resource="form-standards" label="Add Standard" />
                <br/>
                <CreateButton resource="form-key-indicators" label="Add Key Indicator" />
                <br/>
                <CreateButton resource="form-indicators" label="Add Indicator" />
                </div>
                )}
                <FormPreview/>
            </Tab>
            */}
            <Tab label="Form Entries">
                <FormEntriesField/>
            </Tab>
        {/* </SimpleShowLayout> */}
        </TabbedShowLayout>
    </Show>
    )
};

const ShkeFormEditor = () => {
  const input = useController({name: 'schema'});

  return null;
}

export const MyToolbar = () => (
  <Toolbar>
      <SaveButton label="Save" onClick={() => {
        const fields = document.querySelectorAll('.formeo-editor [required]');
          for(const field of fields) {
              field.removeAttribute('required');
          }
      }} />
  </Toolbar>
);

const FormStandardsEditor = () => {
    const record = useRecordContext();

    /*
    <ArrayInput source="items">
                <SimpleFormIterator inline>
                    <TextInput source="name" helperText={false} />
                    <NumberInput source="price" helperText={false} />
                    <NumberInput source="quantity" helperText={false} />
                </SimpleFormIterator>
            </ArrayInput>
    */

    return (<>
        <TabbedForm>
            <ArrayInput source="standards">
                <SimpleFormIterator>
                <TabbedForm.Tab label='name'>
                    <TextField source="name" />
                </TabbedForm.Tab>
                </SimpleFormIterator>
            </ArrayInput>
            {/*
            {record.standards.map((standard, sIndex) => {
                <TabbedForm.Tab label={standard.name}>
                    <TextField source={} />
                </TabbedForm.Tab>
            })}
            */}
        </TabbedForm>
    </>);
    //
};


const CoordinatingProgramFormRedirectInput = ({ canEdit }) => {
    const formId = useWatch({ name: 'form_id' });
    const [nationalRedirect, setNationalRedirect] = React.useState(null);

    React.useEffect(() => {
        if(!formId) {
            setNationalRedirect(null);
            return;
        }
        authenticatedApi.get('/forms/'+formId).then(response => {
            setNationalRedirect(response.data.completion_redirect_url ?? null);
        });
    }, [formId]);

    return (
        <TextInput
            source="completion_redirect_url"
            label="Completion Redirect URL"
            disabled={!canEdit}
            helperText={canEdit
                ? `Leave blank to use National's link (${nationalRedirect || 'None'})`
                : "This may only be changed by Main Street America"}
        />
    );
};


const CoordinatingProgramFormEdit = props => {
    const { permissions } = usePermissions();
    return (
        <Edit {...props} redirect="show" mutationMode="pessimistic">
            <TabbedForm>
                <TabbedForm.Tab label="Summary">
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <Stack>
                                <ReferenceInput source="coordinating_program_id" perPage={-1} reference="coordinating-programs">
                                    <AutocompleteInput optionText="name" isRequired fullWidth />
                                </ReferenceInput>
                                <ReferenceInput source="form_id" perPage={-1} reference="forms" filter={{status: ['beta', 'published', 'archived']}}>
                                    <AutocompleteInput optionText="name" isRequired fullWidth />
                                </ReferenceInput>
                                <SelectInput source="status" emptyText={'Choose...'} choices={toSelectChoices(formStatuses)} />
                                <CoordinatingProgramFormDateInput />
                                <CoordinatingProgramFormRedirectInput canEdit={permissions?.msa} />
                            </Stack>
                        </Grid>
                    </Grid>
                </TabbedForm.Tab>
                {/*
                <TabbedForm.Tab label="Table of Contents">
                    <em>Click on a title to navigate to that specific section.</em>
                    <CreateButton resource="form-standards" label="Add Standard" />
                    <CreateButton resource="form-key-indicators" label="Add Key Indicator" />
                    <CreateButton resource="form-indicators" label="Add Indicator" />

                    <FormPreview mode="edit"/>
                </TabbedForm.Tab>
                */}
                <TabbedForm.Tab label="Form Questions">
                    <AdditionalSchemaInput limitQuestions />
                </TabbedForm.Tab>
            </TabbedForm>

            {/* <SimpleForm toolbar={<MyToolbar />}> */}

                {/* <SelectInput source="section" required choices={sectionChoices} /> */}
                {/* <TextInput source="category" /> */}
                {/* <TextInput source="email_notifications" helperText={"Comma-separate the email addresses who should be notified when this form is filled out"} /> */}

                {/* <SelectInput source="scoring_mode" emptyValue={null} emptyText={'Not Scored'} choices={scoringModeOptions} /> */}
                {/*
                <FormDataConsumer>
                    {({ formData, ...rest }) => formData.scoring_mode && formData.scoring_mode !== null && formData.scoring_mode.indexOf('scored') !== -1 &&
                        <NumberInput source="minimum_score" max={100} helperText="Enter percentage from 0–100" required />
                    }
                </FormDataConsumer>
                */}

                {/* <ShkeFormEditor source="schema" /> */}
                {/* <ShkeAdditionalInfoInput source="additional_info" /> */}
            {/* </SimpleForm> */}
        </Edit>
    );
};


const CoordinatingProgramFormDateInput = props => {
    // const record = useRecordContext(props);
    const formId = useWatch({ name: 'form_id' });

    const [formEndDate, setFormEndDate] = React.useState(null);

    React.useEffect(() => {
      if(!formId) {
        setFormEndDate(null);
        return;
      }

      authenticatedApi.get('/forms/'+formId).then(response => {
        const parsedDate = parseISO(response.data.end_at);
        // const result = formatISO(parsedDate, { representation: 'date' })
        setFormEndDate(parsedDate);//result);//response.data.end_at);
      });
    }, [formId]);

    if(!formEndDate) {
        return null;
    }

    const result = formatISO(formEndDate, { representation: 'date' });
    const localFormatted = format(formEndDate, 'P');

    return <DateInput
        label={`Close On`}
        helperText={`Date must be no later than ${localFormatted}. Leave blank to use National's date`}
        source="end_at"
        validate={maxValue(result, `Date must be no later than ${localFormatted}. Leave blank to use National's date`)}
    />;
};

const CoordinatingProgramFormCreate = props => {
  const { permissions } = usePermissions();
  return (
    <Create {...props} redirect="show">
        <Alert severity="info">Note: It is recommended to duplicate a past form instead of starting from scratch.</Alert>
        <TabbedForm>
            <TabbedForm.Tab label="Summary">
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <Stack>
                            <ReferenceInput source="coordinating_program_id" perPage={-1} reference="coordinating-programs">
                                <AutocompleteInput optionText="name" isRequired fullWidth />
                            </ReferenceInput>
                            <ReferenceInput source="form_id" perPage={-1} reference="forms" filter={{status: ['beta', 'published', 'archived']}}>
                                <AutocompleteInput optionText="name" isRequired fullWidth />
                            </ReferenceInput>
                            <SelectInput source="status" emptyText={'Choose...'} choices={toSelectChoices(formStatuses)} defaultValue={'draft'} />
                            <CoordinatingProgramFormDateInput />
                            <CoordinatingProgramFormRedirectInput canEdit={permissions?.msa} />
                            {/*
                            'additional_schema',
                            'overrides',
                            */}
                        </Stack>
                    </Grid>
                </Grid>
            </TabbedForm.Tab>
            <TabbedForm.Tab label="Form Questions">
                <em>You must save the form once before you can add questions.</em>
                {/* <AdditionalSchemaInput/> */}
            </TabbedForm.Tab>
        </TabbedForm>
    </Create>
)
};

export {CoordinatingProgramFormList, CoordinatingProgramFormShow, CoordinatingProgramFormEdit, CoordinatingProgramFormCreate};
